import { TranslationKey } from '@/shared/i18n';

import { OnscreenOffer } from './getOnscreenOffer';

// The paywall's button: the same ones as the other dashboard paywalls and the Visual tab's "Edit" teaser.
export const getOnscreenPaywallCtaKey = (offer: OnscreenOffer): TranslationKey =>
  offer === 'addOn' ? 'editor.visualTranslation.talkToSales' : 'recordingModals.paywall.choosePlan';
